import { Tracker } from '@leverege/molten/tracking';
export default function TrackClusterToggleMutator(type, plugin, molten) {
  if (type === 'Action') {
    if (plugin.id === 'molten.mapDataViewer.google.Clustering') {
      return {
        ...plugin,
        perform: cxt => {
          const {
            clientProps
          } = cxt.context;
          const {
            overrideModel
          } = clientProps;
          let value;
          if (overrideModel == null || overrideModel.shouldCluster == null || overrideModel.shouldCluster === true) {
            value = false;
          } else {
            value = true;
          }
          Tracker.event('toggleCluster', {
            value
          });
          plugin.perform(cxt);
        }
      };
    }
  }
  return plugin;
}